export const TRANSLATIONS_FR_HOME_QUALITY_AND_ALERTS = {
  "home.qaHarness.card.formDetail": "Detail with form",
  "home.qaHarness.card.reevaluationFeedback": "Reevaluation queued",
  "home.qaHarness.card.inspectionFeedback": "Inspection-only result",
  "home.qaHarness.card.acknowledgedFeedback": "Business action acknowledged",
  "home.qaHarness.card.manualCompletionFeedback": "Manual completion confirmed",
  "home.qaHarness.card.replayFeedback": "Replay result",
  "home.alerts.title": "Requiert votre attention",
  "home.alerts.viewAll": "Tout voir",
  "home.alerts.empty": "Aucune alerte active.",
  "home.alerts.loading": "Chargement...",
  "home.alerts.errorMessage": "Impossible de charger les alertes.",
  "home.alerts.retry": "Reessayer",
};
